import { getHeaders } from './common';
import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'

export const fetchOrganizationUsers = async (orgId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/users/${orgId}`, error_message: "Failed to fetch users" });
};

export const CopyUserInviteLink = async (user_id) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/users/copyInviteUserLink/${user_id}`, error_message: "Failed to fetch invitation link" });
};

export const CompleteTutorial = async (user_id) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_API_URL}/users/complete_tutorial/${user_id}`, error_message: "Failed" });
};

// invite users
export const inviteUser = async (userData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/invite-user`,
            {
                method: "POST",
                headers: getHeaders(),
                body: JSON.stringify(userData),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data, message: "User invited!" };
        } else if (response.status === 400) {
            return {
                success: false,
                error: "The provided email is already taken. Please use another one."
            };
        } else {
            return { success: false, error: "Failed to invite user" };
        }
    } catch (error) {
        console.error("Error inviting user:", error);
        return {
            success: false,
            error: "Failed to invite user. Please check your network connection and try again."
        };
    }
};

// delete user
export const deleteUser = async (userId) => {
    return apiDelete({ endpoint: `${process.env.REACT_APP_API_URL}/admins/${userId}`, successMessage: "User deleted!", error_message: "Failed to delete User" });

};

// update user
export const updateUser = async (userId, userData) => {
    return apiPut({ endpoint: `${process.env.REACT_APP_API_URL}/users/${userId}`, body: userData, successMessage: "User updated!", error_message: "Failed to update user" });
};